module.exports = __webpack_public_path__ + "img/DE00098.fa14712f.png";